import { remoteComponentBind } from "../remote-trigger/browser";
import { initComponent } from "../../utilities/common.js";

export const init = () => {
  initComponent("persistent-cta-link", (element) => {
    remoteComponentBind(element);
  });
};
init();
